export enum NewUserQuestionnaireReason {
    SitePlanForMyEvent = "SitePlanForMyEvent",
    TeamPlanMoreEfficiently = "TeamPlanMoreEfficiently",
    PlanMultipleEventsPerProject = "PlanMultipleEventsPerProject",
    JustCurious = "JustCurious"
}